import { useState, useEffect } from 'react';

export default function useSize() {
  const [size, setSize] = useState({});

  useEffect(() => {
    // if (ref.current == null) return;
    const observer = new ResizeObserver(([entry]) => {
      setSize(entry.contentRect);
    });
    observer.observe(document.querySelector('#multipleMetadataMap'));
    return () => observer.disconnect();
  }, []);

  return size;
}
